import { Cookies } from 'react-cookie';

import axiosInterceptor from 'api/interceptor/axiosClient';

interface RejectTrapResponse {
  status: string;
  trap: string;
}

export const rejectAdminDeviceIntakeTrap = async (serialNumber: string) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const response = await axiosInterceptor.delete<RejectTrapResponse>(
    `v1/admin/device-intake/traps/${serialNumber}/reject`,
    {
      headers: {
        Authorization: token,
      },
    },
  );

  return response.data;
};
